import api from '../api';
import { tokenStorage } from '../../utils/encryptedCookie';

const setAuthHeader = () => {
  const token = tokenStorage.get();
  if (token) {
    return { Authorization: `Bearer ${token}` };
  }
  return {};
};

export const setSettings = async (data) => {
  try {
    const response = await api.put('/configurations', data, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw new Error(
      error.response?.data?.message || 'Erro ao atualizar configurações.'
    );
  }
};

export const getSettings = async () => {
  try {
    const response = await api.get(`/configurations`, {
      headers: setAuthHeader(),
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Erro ao buscar as configurações.');
  }
};